module.exports = ".example-margin {\r\n    margin: 0 10px;\r\n  }"